module.exports = __webpack_public_path__ + "static/media/rober6.65b7e405.jpg";